module.exports = __webpack_public_path__ + "img/Perdues@2x.fddcccf4.png";